import SmEventTickets from './view';

const SmEventTicketsPage = {
    name: 'SmEventTickets',
    list: SmEventTickets
};

export default SmEventTicketsPage;
